import React from 'react';
import { Checkbox } from '@repo/common';
import { WORKSHOP_COLUMN_CLASS as COL } from './workshopColumns';

const HeaderItem = ({ label, children, className, align = 'center' }) => {
  const alignmentClass = align === 'left' ? 'items-start' : 'items-center';

  return (
    <div
      className={`flex flex-col justify-center ${alignmentClass} px-2 py-3 relative z-10 text-text-primary ${className}`}
    >
      <span className='typo-b13Strong'>{label}</span>
      <span className='typo-b11'>{children}</span>
    </div>
  );
};

const WorkshopListHeader = ({ isAllSelected, onSelectAll, isDeleted }) => {
  return (
    <div className='hidden tabletV:flex w-full items-start pb-4'>
      <div className='flex w-full items-start border-b-[1.6px] border-grayscale-gray01'>
        <div className={`flex py-3 items-center gap-2.5 ${COL.check}`}>
          <Checkbox checked={isAllSelected} onChange={onSelectAll} />
        </div>
        <div className={`flex py-3 items-center ${COL.thumb}`}>
          <div className='w-6 h-6' />
        </div>
        {isDeleted ? (
          <>
            <HeaderItem className={COL.deletedAt} label='Deleted at' />
            <HeaderItem className={COL.name} label='Workshop name' />
            <HeaderItem className={COL.date} label='Date' />
            <HeaderItem className={COL.timeDeleted} label='Time' />
            <HeaderItem className={COL.confirmed} label='Confirmed' align='left'>
              (Remaining / Capacity)
            </HeaderItem>
            <HeaderItem className={COL.impact} label='Cancellation Impact' align='left'>
              (Waitlisted / Bookings)
            </HeaderItem>
            <HeaderItem className={COL.status} label='Status at Deletion' />
          </>
        ) : (
          <>
            <HeaderItem className={COL.date} label='Date' />
            <HeaderItem className={COL.time} label='Time' />
            <HeaderItem className={COL.category} label='Category' />
            <HeaderItem className={COL.name} label='Workshop name' />
            <HeaderItem className={COL.confirmed} label='Confirmed' align='left'>
              (Remaining / Capacity)
            </HeaderItem>
            <HeaderItem className={COL.waitlist} label='Waitlist' align='left'>
              (Waitlisted / Offered)
            </HeaderItem>
            <HeaderItem className={COL.status} label='Status' />
          </>
        )}
        <div className={`flex justify-center items-center ${COL.options}`} />
      </div>
    </div>
  );
};

export default WorkshopListHeader;
